<template>
    <div>
        <div class="menu" :class="{'minimized': sidePanel.minimized, 'details': sidePanel.details}">
            <ul :class="{'hide-details': !sidePanel.details}">
                <li class="sub-header">
                    Conference
                </li>
                <router-link :to="{name: 'conf-information'}" custom v-slot="{ navigate, isActive }" active-class="active">

                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Conference Information" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-circle-info"></i>
                        </b-tooltip><span class="nav-title">Conference Information</span>
                        <div class="meta">View conference information and instructions.</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'schedule'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Sessions & Schedule" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-calendar-circle-user"></i>
                        </b-tooltip><span class="nav-title">Sessions & Schedule</span>
                        <div class="meta">View, access and plan for the different sessions available.</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'on-demand'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="On-Demand Content" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clapperboard-play"></i>
                        </b-tooltip><span class="nav-title">On-Demand Content</span>
                        <div class="meta">Watch content on-demand.</div>
                    </li>
                </router-link>


                <li class="sub-header">
                    Registration & Records
                </li>

                <router-link :to="{name: 'record-log'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Record & Attendance Log" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-clipboard-list-check"></i>
                        </b-tooltip><span class="nav-title">Record & Attendance Log</span>
                        <div class="meta">Your log of attended sessions, on-demand content, and other qualifying activities.</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'conf-applications'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Certifications & Forms" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-certificate"></i>
                        </b-tooltip><span class="nav-title">Certifications & Forms</span>
                        <div class="meta">Apply for certifications and retrieve official completion forms or certificates.</div>
                        <div class="meta mt-3" v-if="registration.isIncompleteApps"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'registration'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Your Registration" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-id-badge"></i>
                        </b-tooltip><span class="nav-title">Your Registration</span>
                        <div class="meta">Access your conference registration information.</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'po-request'}" custom v-slot="{ navigate, isActive }" active-class="active" v-if="registration.is_po_pending">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Purchase Order (P.O.)" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-invoice"></i>
                        </b-tooltip><span class="nav-title">Purchase Order (P.O.)</span>
                        <div class="meta">Manage the the purchase order process.</div>
                        <div class="meta mt-3"><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Action is Required</div>
                    </li>
                </router-link>

            </ul>
        </div>
        <div class="controls ">
            <div class="columns is-gapless">
                <div class="column has-text-right">
                    <span @click="toggleDetails()" v-if="!sidePanel.minimized"><i class="fad mt-2 mr-3" :class="{'fa-bars': sidePanel.details, 'fa-diagram-cells': !sidePanel.details}"></i></span>
                    <span @click="minimize(false)" v-if="sidePanel.minimized"><i class="fad fa-chevrons-right mt-2"></i></span>
                    <span @click="minimize(true)" v-else><i class="fad fa-chevrons-left mt-2"></i></span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import pkg from '../../../package.json';
    import moment from "moment";

    export default {
        name: "ConfSideNav",
        data: function() {
            return {
                details: true,
                version: pkg.version
            };
        },
        computed: {
            ...mapGetters(['currentUser', 'sidePanel', 'registration']),
            incompleteApps: function() {
                // if (this.registration && this.registration.applications) {
                //     if (this.registration.applications.length === 0) return false;
                //     return this.registration.applications.filter(app => !app.completed_at).length > 0;
                // } else {
                //     return false;
                // }

                // for (let confApp of this.registration.conference.applications) {
                //     let enrollApplication = this.registration.applications.find((enrollApp) => {
                //         return enrollApp.conf_application_id === confApp.id;
                //     });
                //     if (moment(this.registration.conference.start_at).isBefore(moment()) && this.registration.reg_record_log.length > 0 && !enrollApplication || (enrollApplication && !enrollApplication.completed_at)) {
                //         return true;
                //     }
                // }
                return false;
            }
        },
        methods: {
            toggleDetails: function() {
                this.$store.commit('setDetails', !this.sidePanel.details);
            },
            minimize: function(state) {
                this.$store.commit('setMinimized', state);
            }
        },
        mounted() {
            let width = window.innerWidth;
            if (width < 768) {
                this.$store.commit('setMinimized', true);
                // this.$store.commit('setDetails', false);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/sidemenu";
</style>
